/**
 * APP-LIKE TOUCH BEHAVIOUR (maintainer, 19 Aug 2026) — the long-press browser menu and the blue
 * selection box do not belong in an installed PWA. This is the same suppression the outfit tiles
 * already carried (`-webkit-touch-callout`, `user-select`, tap-highlight in `styles.css`), lifted
 * to the whole app.
 *
 * CSS kills the tap-highlight and the text selection; this kills the CONTEXT MENU a long-press
 * (or a right-click) raises on links, images and rows — which CSS alone does not do on Android.
 *
 * ⚠️ EDITABLE FIELDS ARE SPARED, deliberately: long-pressing inside an `input`, `textarea` or a
 * `contenteditable` must still raise the paste / select menu, or editing a note or a search box
 * loses its clipboard. So the menu is prevented everywhere EXCEPT inside an editable field.
 */
export function installTouchBehaviour(): void {
  document.addEventListener('contextmenu', (event) => {
    const target = event.target;
    if (target instanceof Element && target.closest('input, textarea, [contenteditable="true"]')) {
      return; // let the field's own paste/select menu through
    }
    event.preventDefault();
  });
}
